import React, { useState, useEffect } from 'react'
import emailjs from '@emailjs/browser'

const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' })
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [timeRemaining, setTimeRemaining] = useState(0)

    const RATE_LIMIT_MS = 5 * 60 * 1000 // 5 minutes in milliseconds

    // Check rate limit on component mount and set up interval
    useEffect(() => {
        checkRateLimit()

        // Update countdown every second
        const interval = setInterval(() => {
            checkRateLimit()
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const checkRateLimit = () => {
        const lastSubmitTime = localStorage.getItem('lastEmailSubmit')
        if (lastSubmitTime) {
            const timeSinceLastSubmit = Date.now() - parseInt(lastSubmitTime)
            const remaining = RATE_LIMIT_MS - timeSinceLastSubmit

            if (remaining > 0) {
                setTimeRemaining(Math.ceil(remaining / 1000)) // Convert to seconds
                return false
            }
        }
        setTimeRemaining(0)
        return true
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const secs = seconds % 60
        return `${minutes}:${secs.toString().padStart(2, '0')}`
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setError(null)

        // Check rate limit
        if (!checkRateLimit()) {
            setError(`Please wait ${formatTime(timeRemaining)} before sending another message.`)
            return
        }

        setLoading(true)

        const serviceID = 'service_y4c5kgj'
        const templateID = 'template_p7z2cmt'
        const publicKey = 'o5CiPIfPa0NiTsfTh'

        const templateParams = {
            name: formData.name,
            from_email: formData.email,
            message: formData.message
        }

        emailjs.send(serviceID, templateID, templateParams, publicKey)
            .then((response) => {
                console.log('Email sent successfully!', response.status, response.text)

                // Save timestamp to localStorage
                localStorage.setItem('lastEmailSubmit', Date.now().toString())

                setSubmitted(true)
                setFormData({ name: '', email: '', message: '' })
                setTimeRemaining(300) // 5 minutes in seconds

                setTimeout(() => setSubmitted(false), 5000)
            })
            .catch((err) => {
                console.error('Failed to send email:', err)
                setError('Failed to send message. Please try again later.')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const isRateLimited = timeRemaining > 0

    return (
        <section id="contact" className="contact">
            <div className="container">
                <h2 className="section-title">Get In Touch</h2>
                {submitted ? (
                    <div className="form-success-message">
                        Thank you for your message! We'll be in touch soon.
                    </div>
                ) : (
                    <form className="contact-form" onSubmit={handleSubmit}>
                        {error && (
                            <div className="form-error-message">
                                {error}
                            </div>
                        )}

                        {isRateLimited && !error && (
                            <div className="form-info-message">
                                You can send another message in {formatTime(timeRemaining)}
                            </div>
                        )}

                        <div className="form-group">
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                disabled={loading || isRateLimited}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="email"
                                name="email"
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                disabled={loading || isRateLimited}
                            />
                        </div>
                        <div className="form-group">
                            <textarea
                                name="message"
                                rows="5"
                                placeholder="Your Message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                disabled={loading || isRateLimited}
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            className="submit-btn"
                            disabled={loading || isRateLimited}
                        >
                            {loading
                                ? 'Sending...'
                                : isRateLimited
                                    ? `Wait ${formatTime(timeRemaining)}`
                                    : 'Send Message'}
                        </button>
                    </form>
                )}
            </div>
        </section>
    )
}

export default Contact